import { useRef, useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './Header.module.scss';
import { Container } from '../../Container/Container';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { HeartIcon } from '../../Icons/Heart';
import { CartIcon } from '../../Icons/Cart';
import { UserIcon } from '../../Icons/User';
import { useTypedSelector } from '../../../lib/hooks/useTypedSelector';
import { LogoIcon } from '../../Icons/Logo';
import useAuth from '../../../hooks/useAuth';
import Search from '../Search/Search';
import { useActions } from '../../../lib/hooks/useActions';
import Home from '../../Icons/Home';
import Catalog from '../../Icons/Catalog';
import Cart from '../../Icons/CartIcon';
import Favorite from '../../Icons/Favourite';
import Profile from '../../Icons/Profile';
import ArrowSmall from '../../Icons/ArrowSmall';
import { CrossIcon } from '../../Icons/Cross';

const Header = () => {
  const { cart } = useTypedSelector((state) => state);
  const { isAuthenticated } = useAuth();

  const { setFilter } = useActions();
  const navigate = useNavigate();

  const location = useLocation();

  const modalRef = useRef<HTMLDivElement | null>(null);
  const btnModalRef = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = () => {
    if (isOpen) {
      setIsOpen(false);
      document.body.style.overflow = 'auto';
    } else {
      setIsOpen(true);
      document.body.style.overflow = 'hidden';
    }
  };

  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';

    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        btnModalRef.current &&
        !btnModalRef.current.contains(event.target as Node)
      )
        setIsOpen(false);
      document.body.style.overflow = 'auto';
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <header className={styles.Header}>
        <Container>
          <nav className={styles.nav}>
            <Link to="/" className={clsx(styles.logo, styles.item)}>
              <LogoIcon />
            </Link>
            <Link to="/catalog" className={clsx(styles.catalog, styles.item)}>
              <div className={styles.burger}>
                <div className={styles.burgerLine}></div>
                <div className={styles.burgerLine}></div>
                <div className={styles.burgerLine}></div>
              </div>
              Каталог
            </Link>
            <ul className={clsx(styles.list, styles.item)}>
              <li className={styles.listItem}>
                <Link to="/documentation">Информация</Link>
              </li>
              <li className={styles.listItem}>
                <Link to="/company">О компании</Link>
              </li>
              <li className={styles.listItem}>
                <Link to="/news">Новости</Link>
              </li>
            </ul>
            <Link to="/favorites" className={styles.item}>
              <HeartIcon />
            </Link>
            <Link to="/cart" className={styles.item}>
              <CartIcon className={styles.icon} />
              {cart.length}
            </Link>
            {isAuthenticated ? (
              <Link to="/account" className={styles.item}>
                <UserIcon className={styles.icon} />
              </Link>
            ) : (
              <Link to="/login" className={styles.item}>
                <UserIcon className={styles.icon} />
                Войти
              </Link>
            )}
            <button
              className={styles.mobile_menu_btn}
              ref={btnModalRef}
              onClick={() => toggleModal()}
            >
              {!isOpen ? (
                <div className={styles.burger}>
                  <div className={styles.burgerLine}></div>
                  <div className={styles.burgerLine}></div>
                  <div className={styles.burgerLine}></div>
                </div>
              ) : (
                <CrossIcon />
              )}
            </button>
            <Search
              onSearch={(value) => {
                setFilter({ key: 'search', value });
                navigate(`/catalog?search=${value}`);
              }}
              className={styles.header_search}
            />
          </nav>
        </Container>
      </header>
      <div className={styles.mpbile_btns}>
        <Link
          to="/"
          className={clsx({ [styles.active]: location.pathname === '/' })}
        >
          <Home />
          Главная
        </Link>
        <Link
          to="/catalog"
          className={clsx({
            [styles.active]: location.pathname === '/catalog',
          })}
        >
          <Catalog className={styles.catalogIcon} />
          Каталог
        </Link>
        <Link
          to="/cart"
          className={clsx({ [styles.active]: location.pathname === '/cart' })}
        >
          <Cart />
          Корзина
        </Link>
        <Link
          to="/favorites"
          className={clsx({
            [styles.active]: location.pathname === '/favorites',
          })}
        >
          <Favorite />
          Избранное
        </Link>
        <Link
          to="/login"
          className={clsx({
            [styles.active]:
              location.pathname === '/account' ||
              location.pathname === '/login',
          })}
        >
          <Profile />
          {isAuthenticated ? 'Профиль' : 'Войти'}
        </Link>
      </div>
      <div
        className={clsx(styles.popup, { [styles.open]: isOpen })}
        ref={modalRef}
      >
        <div className={styles.scroll_content}>
          <Link to="/catalog" onClick={() => toggleModal()}>
            Каталог
            <ArrowSmall />
          </Link>
          <Link to="/brands" onClick={() => toggleModal()}>
            Бренды
            <ArrowSmall />
          </Link>
          <Link to="/documentation" onClick={() => toggleModal()}>
            Информация
            <ArrowSmall />
          </Link>
          <Link to="/company" onClick={() => toggleModal()}>
            О компании
            <ArrowSmall />
          </Link>
          <Link to="/news" onClick={() => toggleModal()}>
            Новости
            <ArrowSmall />
          </Link>
          <Link
            to="/account"
            onClick={() => toggleModal()}
            className={styles.auth_btn}
          >
            <Profile />
            {isAuthenticated ? 'Профиль' : 'Войти в ЛК'}
          </Link>
        </div>
      </div>
    </>
  );
};

export default Header;
